import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "end_text public_flex_center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "404", -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "head_bg" }, null, -1 /* HOISTED */)

import { ref } from 'vue';
import { RuleType } from './utils/type';
import { getQueryString } from '@activity-business/h5-package-frameworkTool';
import {fnGetInjectInfo} from '@components/developTool_Share';


export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const {
    TOOL_countryCode,
    TOOL_RULE,
    TOOL_TEXT,
    TOOL_DOMAIN,
    TOOL_activityId,
    TOOL_activityInfo
} = fnGetInjectInfo();

let refRuleType = ref<RuleType>(RuleType['规则1']);

const methodsClickActivityRuleType = (ruleType: RuleType) => refRuleType.value = ruleType;

const handleClickTopBtn = () => {
    let url = `https://mico.onelink.me/O5Dq/fcgadroe?entrance=11&business_type=1&func_type=1&encrypt=${getQueryString('encrypt')}&click_time=${Date.now()}`;
    console.log(url)
    window.location.href = url
}



return (_ctx: any,_cache: any) => {
  return (_ctx.MIXIN_ACTIVITY_INFO.isEnd)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _hoisted_4,
        _createElementVNode("div", { class: "top_bar" }, [
          _createElementVNode("div", {
            class: "top_btn",
            onClick: handleClickTopBtn
          })
        ])
      ], 64 /* STABLE_FRAGMENT */))
}
}

})